import { useState, type JSX } from 'react';
import WsModalCreateContent from 'pages/ws/components/modalCreateContent/WsModalCreateContent';

/**
 * レポート画面 0件表示コンポーネント
 */
export default function WsReportSearchEmpty(): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  const [modalCreateContentOpenState, setModalCreateContentOpenState] = useState(false);

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * コンテンツ作成モーダルを開く
   */
  const onModalCreateContentOpen = () => {
    setModalCreateContentOpenState(true);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <section className="section-contents">
        <div className="container">
          <div className="d-flex flex-column justify-content-center align-items-center">
            <h3 className="text-lead text-center">
              コンテンツを稼働させるとレポートが作成されます。
            </h3>
            <a
              onClick={onModalCreateContentOpen}
              className="btn btn-common btn-common-w238 outline-blue"
            >
              + 新しいコンテンツを作成する
            </a>
          </div>
        </div>
      </section>
      {/* コンテンツ作成モーダル */}
      <WsModalCreateContent
        open={modalCreateContentOpenState}
        setOpen={setModalCreateContentOpenState}
      />
    </>
  );
}
